import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedFareFamily = () => {
  return {};
};

export default {
  state: () => ({
    selectedFareFamily: getDefaultSelectedFareFamily(),
    fareFamilies: [],
  }),

  mutations: {
    setSelectedFareFamily(state, fareFamily) {
      Vue.set(state, "selectedFareFamily", fareFamily);
    },
    setFareFamilies(state, fareFamilies) {
      Vue.set(state, "fareFamilies", fareFamilies);
    },
    setDefaultSelectedFareFamily(state) {
      Vue.set(state, "selectedFareFamily", getDefaultSelectedFareFamily());
    },
    setDefaultFareFamilyModule(state) {
      Vue.set(state, "selectedFareFamily", getDefaultSelectedFareFamily());
      Vue.set(state, "fareFamilies", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createFareFamily: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/fare-families/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadFareFamilies: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/fare-families/entity").then((response) => {
        context.commit("setFareFamilies", response.data);
        return response.data;
      });
    },

    loadFareFamily: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/fare-families/entity/" + request.id).then((response) => {
        return response.data;
      });
    },

    loadFareFamilyCabinClasses: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/fare-families/get-fare-families-cabin-class-ids").then((response) => {
        return response;
      });
    },

    loadPublishedFareFamilies: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/fare-families/entity/published").then((response) => {
        return response.data;
      });
    },

    loadFareFamilyHistory: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/inventory/fare-families/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    loadSelectedFareFamilyHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/fare-families/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    searchFareFamilyByStationId: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/inventory/fare-families/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    deleteFareFamily: (context, fareFamily) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/fare-families/entity/" + fareFamily.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          fareFamily.intents = intents;
          fareFamily.intentId = response.data.id;
          return fareFamily;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftFareFamily: (context, fareFamily) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/fare-families/draft/" + fareFamily.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    publishFareFamily: (context, fareFamily) => {
      return axios.get(context.getters.getMcServiceUrl + "/fare-families/publish/" + fareFamily.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectFareFamily: (context, fareFamily) => {
      return axios.get(context.getters.getMcServiceUrl + "/fare-families/reject/" + fareFamily.intentId).then((response) => {
        if (fareFamily.intents[0].type === "DELETE_FARE_FAMILY") {
          fareFamily.intents = null;
          fareFamily.intentId = 0;
        } else if (fareFamily.intents[0].type === "CREATE_FARE_FAMILY") {
          fareFamily.intents[0].status = "DRAFT";
        } else if (fareFamily.intents[0].type === "UPDATE_FARE_FAMILY") {
          fareFamily.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    recallFareFamily: (context, fareFamily) => {
      return axios.get(context.getters.getMcServiceUrl + "/fare-families/recall/" + fareFamily.intentId).then((response) => {
        helper.recallOrRejectEntity(fareFamily, "FARE_FAMILY");
        return response.data;
      });
    },

    cancelFareFamily: (context, fareFamily) => {
      return axios.get(context.getters.getMcServiceUrl + "/fare-families/cancel/" + fareFamily.intentId).then((response) => {
        return response.data;
      });
    },

    sendToApprovalFareFamilies: (context, fareFamily) => {
      return axios.get(context.getters.getMcServiceUrl + "/fare-families/sendToApproval/" + fareFamily.intentId).then((response) => {
        if (fareFamily.intents[0].type === "CREATE_FARE_FAMILY") {
          fareFamily.intents[0].status = "WAITING_APPROVAL";
        } else if (fareFamily.intents[0].type === "UPDATE_FARE_FAMILY") {
          fareFamily.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
  },

  getters: {
    getSelectedFareFamily: (state) => {
      return state.selectedFareFamily;
    },
    getFareFamilies: (state) => {
      return state.fareFamilies;
    },
  },
};
